<script lang="ts">
  import MyCoffees from '$lib/components/myCoffees/MyCoffees.svelte';
</script>

<svelte:head>
  <title>Coffee Pal - My Coffees</title>
</svelte:head>

<MyCoffees />
